import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBataComponent } from './simple-icons-bata.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBataComponent ],
    exports:      [ SimpleIconsBataComponent ],
    bootstrap:    []
})
export class SimpleIconsBataModule {}
